
import { BusinessAssessment } from "@/components/BusinessAssessment";
import { useNavigate } from "react-router-dom";

const Assessment = () => {
  const navigate = useNavigate();

  const handleAssessmentComplete = () => {
    // After assessment completion, redirect to dashboard
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <BusinessAssessment onComplete={handleAssessmentComplete} />
    </div>
  );
};

export default Assessment;
